export default function spinner () {
  return (<span className="btn-spinner"></span>);
}
